import {postRequest} from "./ApiService";

export function registerInfraction(data){
    return postRequest('registerInfraction', data)
}
